var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6668 0H7.3335V2.22222H20.6668V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7779 28.8887H25.1112V6.66644L20.6667 4.44421H7.33341L2.88897 6.66644V28.8887H6.2223L0.666748 39.9998H2.88897L4.00008 37.7775H24.0001L25.1112 39.9998H27.3334L21.7779 28.8887ZM5.11119 8.04421L7.86675 6.66644H20.1334L22.889 8.04421V15.5553H5.11119V8.04421ZM5.11119 26.6664V17.7775H22.889V26.6664H5.11119ZM19.5556 28.8887L20.6667 31.1109H7.33341L8.44453 28.8887H19.5556ZM5.11119 35.5553L6.2223 33.3331H21.7779L22.889 35.5553H5.11119Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55572 22.2224H7.3335V24.4446H9.55572V22.2224Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6658 22.2224H18.4436V24.4446H20.6658V22.2224Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.036865e839c56031043f770eb264b4f7.svg";
export { ForwardRef as ReactComponent };